export function openURLNewTab(url: string): void {
  if (typeof window === "undefined") {
    // Prevent running on server
    return;
  }

  if (!url || typeof url !== "string") {
    console.error("Invalid URL");
    return;
  }

  const fullURL =
    url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  const newTab = window.open(fullURL, "_blank");

  if (newTab) {
    newTab.focus();
  } else {
    console.error("Failed to open new tab. Pop-up blocker may be active.");
  }
}
